import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import Cancel from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import Update from '@material-ui/icons/Update'
import Warning from '@material-ui/icons/Warning'
import { JobConsoleStatusDetailUserFacingMap } from 'shared/models/job'

import { ProductSubscriptionBundleName } from '../models/subscription'

export const apiUrl = '/api/v1/console'
export const fusionApiUrl = '/api/v3'

export const STATUS_CHOICES = [
  { id: 'PENDING', name: 'Pending' },
  { id: 'FUTURE', name: 'Future' },
  { id: 'CURRENT', name: 'Current' },
  { id: 'PAST', name: 'Past' },
]

export const TEAM_COMPOSITION_CHOICES = [
  { id: 'LOO', name: 'Lease Owner-Operator' },
  { id: 'CD', name: 'Commercial Driver' },
  { id: 'OOA', name: 'Owner-Operator with Authority' },
]

export const TEAM_STATUS_CHOICES = [
  { id: true, name: 'Approved' },
  { id: false, name: 'Not Approved' },
]

export const TEAM_OFFBOARDING_STATUSES = {
  Offboarding: 'OFFBOARDING',
  Offboarded: 'OFFBOARDED',
}

export const BACKGROUND_CHECK_REPORT_STATUS_CHOICES = [
  { id: 'pending', name: 'Pending' },
  { id: 'clear', name: 'Clear' },
  { id: 'consider', name: 'Consider' },
  { id: 'complete', name: 'Complete' },
  { id: 'suspended', name: 'Suspended' },
  { id: 'dispute', name: 'Dispute' },
]

// Job status
export const JobStatus = {
  Pending: 'PENDING',
  Future: 'FUTURE',
  Current: 'CURRENT',
  Past: 'PAST',
}

export const JOB_ACTIVE_STATUSES = [JobStatus.Pending, JobStatus.Future, JobStatus.Current]

// Job status detail
export const JobStatusDetail = {
  BiddingRequired: 'BIDDING_REQUIRED',
  BookedOffline: 'BOOKED_OFFLINE',
  ActiveNegotiation: 'ACTIVE_NEGOTIATION',
  BrokerSetupRequired: 'BROKER_SETUP_REQUIRED',
  AwaitingRateConfirmation: 'AWAITING_RATE_CONFIRMATION',
  ReviewingRateConfirmation: 'REVIEWING_RATE_CONFIRMATION',
  Aborted: 'ABORTED',
  JobApproved: 'JOB_APPROVED',
  InProgress: 'IN_PROGRESS',
  PendingDeliveryVerification: 'PENDING_DELIVERY_VERIFICATION',
  PaymentRequired: 'PAYMENT_REQUIRED',
  DeliveryVerificationRejected: 'DELIVERY_VERIFICATION_REJECTED',
  PendingPaymentVerification: 'PENDING_PAYMENT_VERIFICATION',
  PaymentIssued: 'PAYMENT_ISSUED',
  Canceled: 'CANCELED',
  RequestedCancellation: 'REQUESTED_CANCELLATION',
  PendingCancellation: 'PENDING_CANCELLATION',
  RecoveryNeeded: 'NEEDS_RECOVERY',
  Recovered: 'RECOVERED',
}

export const STATUS_DETAIL_CHOICES = Object.entries(JobConsoleStatusDetailUserFacingMap).map((key) => {
  return { id: key[0], name: key[1] }
})

export const PendingIconObj = { icon: AssignmentIndIcon, color: 'grey' }
const CompletedIconObj = { icon: CheckCircleIcon, color: 'green' }
const InProgressIconObj = { icon: AutorenewIcon, color: '#258ACE' }
const WarningIconObj = { icon: Warning, color: '#E48900' }

export const JobStatusDetailIconColorMap = {
  [JobStatusDetail.BiddingRequired]: PendingIconObj,
  [JobStatusDetail.BookedOffline]: PendingIconObj,
  [JobStatusDetail.ActiveNegotiation]: PendingIconObj,
  [JobStatusDetail.BrokerSetupRequired]: PendingIconObj,
  [JobStatusDetail.AwaitingRateConfirmation]: PendingIconObj,
  [JobStatusDetail.ReviewingRateConfirmation]: PendingIconObj,
  [JobStatusDetail.Aborted]: { icon: Cancel, color: 'grey' },
  [JobStatusDetail.RequestedCancellation]: WarningIconObj,
  [JobStatusDetail.PendingCancellation]: { icon: Cancel, color: 'grey' },
  [JobStatusDetail.Canceled]: { icon: Cancel, color: 'red' },
  [JobStatusDetail.JobApproved]: { icon: Update, color: '#3498DB' },
  [JobStatusDetail.InProgress]: InProgressIconObj,
  [JobStatusDetail.PendingDeliveryVerification]: InProgressIconObj,
  [JobStatusDetail.PaymentRequired]: InProgressIconObj,
  [JobStatusDetail.DeliveryVerificationRejected]: InProgressIconObj,
  [JobStatusDetail.PendingPaymentVerification]: InProgressIconObj,
  [JobStatusDetail.PaymentIssued]: CompletedIconObj,
  [JobStatusDetail.RecoveryNeeded]: WarningIconObj,
}

// Job status details after the rate con has been confirmed
export const RATE_CON_CONFIRMED_JOB_STATUS_DETAILS = [
  JobStatusDetail.ReviewingRateConfirmation,
  JobStatusDetail.JobApproved,
  JobStatusDetail.InProgress,
  JobStatusDetail.PendingDeliveryVerification,
  JobStatusDetail.DeliveryVerificationRejected,
  JobStatusDetail.PendingPaymentVerification,
  JobStatusDetail.PaymentRequired,
  JobStatusDetail.PaymentIssued,
  JobStatusDetail.Canceled,
]

export const ORIGIN = 'ORIGIN'
export const DESTINATION = 'DESTINATION'

export const TASK_DICTIONARY: Record<any, string> = {
  BIDDING_REQUIRED: 'Contact Broker & Review Rate Confirmation',
  REVIEWING_RATE_CONFIRMATION: 'Approve Job',
  PENDING_DELIVERY_VERIFICATION: 'Verify or Reject Bill of Lading',
  DELIVERY_VERIFICATION_ACCEPTED: 'Issue Payment with Stripe', // TODO (ezennag-delete)
  PAYMENT_REQUIRED: 'Issue Payment with Stripe',
}

export const CashAdvancePaymentStatuses = {
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
  PROCESSED: 'PROCESSED',
}

export const OLD_CONSOLE_RESOURCE_MAP: Record<any, any> = {
  tasks: {
    resourceString: 'jobs',
    resourceDetailString: 'job',
  },
  jobs: {
    resourceString: 'jobs',
    resourceDetailString: 'job',
  },
  statements: {
    resourceString: 'jobs',
    resourceDetailString: 'statement',
  },
  users: {
    resourceString: 'core',
    resourceDetailString: 'customuser',
  },
  teams: {
    resourceString: 'core',
    resourceDetailString: 'team',
  },
  loads: {
    resourceString: 'queryengine',
    resourceDetailString: 'load',
  },
  brokers: {
    resourceString: 'queryengine',
    resourceDetailString: 'broker',
  },
  schedules: {
    resourceString: 'schedules',
    resourceDetailString: 'schedule',
  },
  'edi-loads': {
    resourceString: 'queryengine',
    resourceDetailString: 'ediload',
  },
  trailers: {
    resourceString: 'queryengine',
    resourceDetailString: 'trailer',
  },
}

export const TIMEZONE_CHOICES = [
  { id: 'America/New_York', name: 'America/New_York' },
  { id: 'America/Detroit', name: 'America/Detroit' },
  { id: 'America/Kentucky/Louisville', name: 'America/Kentucky/Louisville' },
  { id: 'America/Kentucky/Monticello', name: 'America/Kentucky/Monticello' },
  { id: 'America/Indiana/Indianapolis', name: 'America/Indiana/Indianapolis' },
  { id: 'America/Indiana/Vincennes', name: 'America/Indiana/Vincennes' },
  { id: 'America/Indiana/Winamac', name: 'America/Indiana/Winamac' },
  { id: 'America/Indiana/Marengo', name: 'America/Indiana/Marengo' },
  { id: 'America/Indiana/Petersburg', name: 'America/Indiana/Petersburg' },
  { id: 'America/Indiana/Vevay', name: 'America/Indiana/Vevay' },
  { id: 'America/Chicago', name: 'America/Chicago' },
  { id: 'America/Indiana/Tell_City', name: 'America/Indiana/Tell_City' },
  { id: 'America/Indiana/Knox', name: 'America/Indiana/Knox' },
  { id: 'America/Menominee', name: 'America/Menominee' },
  { id: 'America/North_Dakota/Center', name: 'America/North_Dakota/Center' },
  {
    id: 'America/North_Dakota/New_Salem',
    name: 'America/North_Dakota/New_Salem',
  },
  { id: 'America/North_Dakota/Beulah', name: 'America/North_Dakota/Beulah' },
  { id: 'America/Denver', name: 'America/Denver' },
  { id: 'America/Boise', name: 'America/Boise' },
  { id: 'America/Phoenix', name: 'America/Phoenix' },
  { id: 'America/Los_Angeles', name: 'America/Los_Angeles' },
  { id: 'America/Anchorage', name: 'America/Anchorage' },
  { id: 'America/Juneau', name: 'America/Juneau' },
  { id: 'America/Sitka', name: 'America/Sitka' },
  { id: 'America/Metlakatla', name: 'America/Metlakatla' },
  { id: 'America/Yakutat', name: 'America/Yakutat' },
  { id: 'America/Nome', name: 'America/Nome' },
  { id: 'America/Adak', name: 'America/Adak' },
  { id: 'Pacific/Honolulu', name: 'Pacific/Honolulu' },
]

export const STOP_TYPE_CHOICES = [
  { id: 'ORIGIN', name: 'Origin' },
  { id: 'DESTINATION', name: 'Destination' },
  { id: 'STOP', name: 'Stop' },
]

// sync with cloudtrucks/queryengine/services.py#L59
export const SUPPORTED_EQUIPMENT_CHOICES = [
  { id: 'DRY_VAN', name: 'Dry Van' },
  { id: 'FLATBED', name: 'Flatbed' },
  { id: 'REEFER', name: 'Reefer' },
  { id: 'POWER_ONLY', name: 'Power Only' },
]

export const TRACTOR_CHOICES = [
  { id: 'DAY_CAB', name: 'Day Cab' },
  { id: 'SLEEPER', name: 'Sleeper Cab' },
]

export const DEFAULT_ERROR_STRING = 'Oops, something went wrong'

// sync with cloudtrucks/schedules/models.py#L177
export const STATUS_ICONS: Record<any, any> = {
  ERROR: {
    name: 'ERROR',
    icon: ErrorOutlineIcon,
  },
  PENDING: {
    name: 'PENDING',
    icon: HourglassEmptyIcon,
  },
  READY: {
    name: 'READY',
    icon: DoneOutlineIcon,
  },
}

// color blind friendly colors from https://www.nature.com/articles/nmeth.1618
export const STATUS_ICON_STYLES = {
  ERROR: { color: '#D55E00' },
  PENDING: { color: '#F0E442' },
  READY: { color: '#009E73' },
}

export const LABEL_JOB_STATUS_DETAIL = 'Job status detail'

export const LABEL_LOAD_SOURCE = 'Load source'

export const LABEL_LOAD_SOURCE_ID = 'Load source ID'

export const LABEL_ORIGIN_TO_DESTINATION = 'Origin → Destination'

export const LABEL_PICKUP_DATE = 'Pickup date'

export const LABEL_DROPOFF_DATE = 'Dropoff date'

export const REFERRAL_SOURCE_CHOICES = [
  { id: 'friend', name: 'Friend' },
  { id: 'social_media', name: 'Social media' },
  { id: 'uber', name: 'Uber' },
  { id: 'other', name: 'Other' },
  { id: 'news_or_newspaper', name: 'News Site or Newspaper' },
]

export const ACTIVE_DRIVER_STATUS_CHOICES = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'APPLYING', name: 'Applying' },
  { id: 'ELIGIBLE', name: 'Eligible' },
  { id: 'ONBOARDING', name: 'Onboarding' },
  { id: 'SUSPENDED_TEMPORARILY', name: 'Suspended' },
]

export const ACTIVE_DRIVER_STATUSES = {
  Applying: 'APPLYING',
  Active: 'ACTIVE',
  Eligible: 'ELIGIBLE',
  Onboarding: 'ONBOARDING',
  Suspended: 'SUSPENDED_TEMPORARILY',
}

export const DRIVER_STATUS_CHOICES = [
  { id: 'PREACTIVE', name: 'Applying Eligible Onboarding' },
  { id: 'ACTIVE', name: 'Active' },
  { id: 'DEACTIVATED', name: 'Deactivated' },
  { id: 'SUSPENDED_TEMPORARILY', name: 'Suspended' },
]

export const DriverStatus = {
  Applying: 'APPLYING',
  Active: 'ACTIVE',
  Eligible: 'ELIGIBLE',
  Onboarding: 'ONBOARDING',
  Inactive: 'INACTIVE',
  Rejected: 'REJECTED',
  Aborted: 'PROCESS_ABORTED',
  Suspended: 'SUSPENDED_TEMPORARILY',
  Deactivated: 'DEACTIVATED',
}

export const RELATED_PROPERTY_FIELD_TYPES = {
  text: 'text',
  stopDateTime: 'stopDateTime',
}

export const LOAD_STOP_WINDOW_TYPES = {
  start: 'date_start',
  end: 'date_end',
}

export const BOOKING_TYPE_CHOICES = [
  { id: 'INSTANT', name: 'Instant' },
  { id: 'STANDARD', name: 'Standard' },
  { id: 'BID', name: 'Bid' },
]

export const BrokerSubmissionMethods = {
  Email: 'EMAIL',
  CarrierPortal: 'CARRIER_PORTAL',
}

export const BrokerSubmissionMethodMap = {
  [BrokerSubmissionMethods.Email]: 'Email',
  [BrokerSubmissionMethods.CarrierPortal]: 'Carrier Portal',
}

export const BROKER_SUBMISSION_METHOD_CHOICES = [
  { id: BrokerSubmissionMethods.Email, name: 'Email' },
  { id: BrokerSubmissionMethods.CarrierPortal, name: 'Carrier Portal' },
]

export const BROKER_PAYMENT_METHOD_CHOICES = [
  { id: 'ACH', name: 'ACH' },
  { id: 'CHECK', name: 'Check' },
]

export const STATEMENT_LINE_ITEM_TYPE_CHOICES = [
  { id: 'LOAD_PRICE', name: 'Load Price' },
  { id: 'TONU', name: 'Truck Ordered Not Used' },
  { id: 'DETENTION', name: 'Detention' },
  { id: 'LAYOVER', name: 'Layover' },
  { id: 'OTHER', name: 'Other' },
]

export const STATEMENT_LINE_ITEM_TYPES = {
  loadPrice: 'LOAD_PRICE',
  tonu: 'TONU',
  detention: 'DETENTION',
  layover: 'LAYOVER',
  other: 'OTHER',
}

// sync with cloudtrucks.schedules.models.Schedule.Source
export const SCHEDULE_SOURCE_CHOICES = [
  { id: 'FLAGGER', name: 'Event Flagger (not optimized)' },
  { id: 'BOOKING', name: 'Booking feasibility check (not optimized)' },
  { id: 'OPTIMIZER', name: 'Schedule Optimizer' },
  { id: 'SHADOW', name: 'Shadow schedule, created to benchmark user behavior' },
  { id: 'PHANTOM', name: 'Phantom schedule, used to explore load space' },
  { id: 'OTHER', name: 'Other source, e.g. manually created' },
]

export const INVOICE_STATUS = {
  draft: 'DRAFT',
  open: 'OPEN',
  paid: 'PAID',
  pastDue: 'PAST_DUE',
  void: 'VOID',
  uncollectable: 'UNCOLLECTABLE',
}

export const INVOICE_STATUS_CHOICES = [
  { id: 'DRAFT', name: 'Draft' },
  { id: 'OPEN', name: 'Open' },
  { id: 'PAID', name: 'Paid' },
  { id: 'PAST_DUE', name: 'Past due' },
  { id: 'VOID', name: 'Void' },
  { id: 'UNCOLLECTABLE', name: 'Uncollectable' },
]

export const INVOICE_CORRECTION_REASON_CHOICES = [
  { id: 'LATE_FEE', name: 'Late Fee' },
  { id: 'LUMPER_FEE', name: 'Lumper Fee' },
  { id: 'ACCESSORIAL', name: 'Accessorial' },
  { id: 'OPS_ERROR', name: 'Ops Error' },
  { id: 'CLAIM_WITHHOLDING', name: 'Claim Withholding' },
  { id: 'BROKER_FUEL_ADVANCE', name: 'Broker Fuel Advance' },
  { id: 'PAPERWORK_MISSING', name: 'Paperwork Missing' },
  { id: 'SENT_PAST_WINDOW', name: 'Sent Past Window' },
  { id: 'OTHER', name: 'Other' },
]

export const FSM_TRANSITION_RECORD_TYPE = {
  job: 'JOB',
  invoice: 'INVOICE',
  issue: 'ISSUE',
  driver: 'DRIVER',
  team: 'TEAM',
}

export const StatementType = {
  Job: 'JOB',
  JobCorrection: 'JOB_CORRECTION',
}

export const StatementTypeChoices = [
  { id: 'JOB', name: 'Job' },
  { id: 'JOB_CORRECTION', name: 'Job Correction' },
]

export const StatementStatus = {
  Draft: 'DRAFT',
  Open: 'OPEN',
  Processed: 'PROCESSED',
  Void: 'VOID',
}

export const StatementStatusChoices = [
  { id: 'DRAFT', name: 'Draft' },
  { id: 'OPEN', name: 'Open' },
  { id: 'PROCESSED', name: 'Processed' },
  { id: 'VOID', name: 'Void' },
]

export const DispatchJobState = {
  scheduled: 'SCHEDULED',
  enRoute: 'EN_ROUTE',
  arrived: 'ARRIVED',
  completed: 'COMPLETED',
  unassigned: 'UNASSIGNED',
  skipped: 'SKIPPED',
}

export const TeamCompositionMap = {
  LOO: 'Lease Owner-Operator',
  CD: 'Commercial Driver',
  OOA: 'Owner-Operator with Authority',
  NA: 'N/A',
}

export const IssueStatus = {
  Reported: 'REPORTED',
  ResolutionPending: 'RESOLUTION_PENDING',
  EscalatedToBroker: 'ESCALATED_TO_BROKER',
  Resolved: 'RESOLVED',
  Rejected: 'REJECTED',
}

export const IssueStatusChoices = [
  { id: IssueStatus.Reported, name: 'Reported' },
  { id: IssueStatus.ResolutionPending, name: 'Resolution Pending' },
  { id: IssueStatus.Resolved, name: 'Resolved' },
  { id: IssueStatus.Rejected, name: 'Rejected' },
]

export const TERMINAL_ISSUE_STATUSES = [IssueStatus.Resolved, IssueStatus.Rejected]

export const IssueType = {
  Lumper: 'LUMPER',
  Tonu: 'TONU',
  Detention: 'DETENTION',
  Layover: 'LAYOVER',
  LongWait: 'LONG_WAIT',
  RunningLate: 'RUNNING_LATE',
  AppointmentNumber: 'APPOINTMENT_NUMBER',
  OverageShortageDamage: 'OVERAGE_SHORTAGE_DAMAGE',
  Breakdown: 'BREAKDOWN',
  Accident: 'ACCIDENT',
  Payment: 'PAYMENT',
  Other: 'OTHER',
  JobApproved: 'JOB_APPROVED',
  BidStatus: 'BID_STATUS',
  BrokerApproved: 'BROKER_APPROVED',
  CashAdvance: 'CASH_ADVANCE',
}

export const IssueTypeChoices = [
  { id: IssueType.Lumper, name: 'Lumper' },
  { id: IssueType.Tonu, name: 'TONU' },
  { id: IssueType.Detention, name: 'Detention' },
  { id: IssueType.Layover, name: 'Layover' },
  { id: IssueType.LongWait, name: 'Long wait at facility' },
  { id: IssueType.RunningLate, name: 'Running late' },
  { id: IssueType.AppointmentNumber, name: 'Appointment number' },
  { id: IssueType.OverageShortageDamage, name: 'OS&D' },
  { id: IssueType.Breakdown, name: 'Breakdown' },
  { id: IssueType.Accident, name: 'Accident' },
  { id: IssueType.Payment, name: 'Payment' },
  { id: IssueType.Other, name: 'Other' },
  { id: IssueType.JobApproved, name: 'Job Approved' },
  { id: IssueType.BidStatus, name: 'Bid Status' },
  { id: IssueType.BrokerApproved, name: 'Broker Approved' },
  { id: IssueType.CashAdvance, name: 'Pickup Pay' },
]

export const GenericIssueType = {
  Payment: 'PAYMENT',
  CashAdvance: 'CASH_ADVANCE',
  OtherPayment: 'OTHER_PAYMENT',
  SafetyCompliance: 'SAFETY_COMPLIANCE',
  ShipperLoads: 'SHIPPER_LOADS',
  Trailers: 'TRAILERS',
  Accident: 'ACCIDENT',
  Breakdown: 'BREAKDOWN',
  Other: 'OTHER',
}

export const GenericIssueTypeChoices = [
  { id: GenericIssueType.Payment, name: 'Payment' },
  { id: GenericIssueType.CashAdvance, name: 'Pickup pay' },
  { id: GenericIssueType.OtherPayment, name: 'Other Payment' },
  { id: GenericIssueType.SafetyCompliance, name: 'Safety & Compliance' },
  { id: GenericIssueType.ShipperLoads, name: 'Shipper Loads' },
  { id: GenericIssueType.Trailers, name: 'Trailers' },
  { id: GenericIssueType.Accident, name: 'Accident' },
  { id: GenericIssueType.Breakdown, name: 'Breakdown' },
  { id: GenericIssueType.Other, name: 'Other' },
]

export const LoadIssueType = {
  Booking: 'BOOKING',
  Other: 'OTHER',
}

export const LoadIssueTypeChoices = [
  { id: LoadIssueType.Booking, name: 'Booking' },
  { id: LoadIssueType.Other, name: 'Other' },
]

export const LoadingTypeChoices = [
  { id: 'DROP', name: 'Drop' },
  { id: 'LIVE', name: 'Live' },
  { id: 'PRELOADED', name: 'Preloaded' },
]

export const LoadingType = {
  Drop: 'DROP',
  Live: 'LIVE',
  Preloaded: 'PRELOADED',
}

export const StopTypeDetailChoices = [
  { id: 'PREHAUL', name: 'Prehaul' },
  { id: 'PICKUP', name: 'Pickup' },
  { id: 'DELIVERY', name: 'Delivery' },
]

export const StopTypeDetail = {
  Prehaul: 'PREHAUL',
  Pickup: 'PICKUP',
  Delivery: 'DELIVERY',
}

export const ContactedLoadStatus = {
  Booked: 'BOOKED',
  Expired: 'EXPIRED',
  NotInterested: 'NOT_INTERESTED',
  Autobid: 'AUTOBID',
  Contacted: 'CONTACTED',
}

export const ContactedLoadStatusChoices = [
  { id: ContactedLoadStatus.Contacted, name: 'Contacted' },
  { id: ContactedLoadStatus.Autobid, name: 'Autobid' },
]

export const CustomLoadSearchVisibilityChoices = [
  { id: 'True', name: 'Visible' },
  { id: 'False', name: 'Hidden' },
]

export const CustomLoadDefaultSource = 'external'

export const BookingTypes = {
  InstantBook: 'INSTANT_BOOK',
  SubmitBid: 'SUBMIT_BID',
  StandardBook: 'STANDARD_BOOK',
  OfflineBook: 'OFFLINE_BOOK',
}

export const DocumentTypes = {
  RateConfirmation: 'RATE_CONFIRMATION',
}

export const ELDType = {
  Samsara: 'SAMSARA',
  KeepTruckin: 'KEEP_TRUCKIN',
  TruckerCloud: 'TRUCKERCLOUD',
}

export const ELDTypeName = {
  [ELDType.Samsara]: 'Samsara',
  [ELDType.KeepTruckin]: 'KeepTruckin',
  [ELDType.TruckerCloud]: 'TruckerCloud',
}

export const ELDTypeChoices = [
  { id: ELDType.Samsara, name: ELDTypeName[ELDType.Samsara] },
  { id: ELDType.KeepTruckin, name: ELDTypeName[ELDType.KeepTruckin] },
]

export const OwnershipType = {
  Own: 'OWN',
  Lease: 'LEASE',
  Rent: 'RENT',
}

export const OwnershipTypeChoices = [
  { id: OwnershipType.Own, name: 'Own' },
  { id: OwnershipType.Lease, name: 'Lease' },
  { id: OwnershipType.Rent, name: 'Rent' },
]

export const EquipmentSource = {
  ArrowTruckSales: 'ARROW_TRUCK_SALES',
  Coop: 'COOP',
  Crossroads: 'CROSSROADS',
  Metro: 'METRO',
  Milestone: 'MILESTONE',
  NorthAmerica: 'NORTH_AMERICAN',
  OTR: 'OTR',
  Penske: 'PENSKE',
  Premier: 'PREMIER',
  Xtra: 'XTRA',
  Other: 'OTHER',
}

export const TruckSourceChoices = [
  { id: EquipmentSource.ArrowTruckSales, name: 'Arrrow Truck Sales' },
  { id: EquipmentSource.Crossroads, name: 'Crossroads' },
  { id: EquipmentSource.OTR, name: 'OTR' },
  { id: EquipmentSource.Other, name: 'Other' },
]

export const TrailerSourceChoices = [
  { id: EquipmentSource.Coop, name: 'Coop' },
  { id: EquipmentSource.Metro, name: 'Metro' },
  { id: EquipmentSource.Milestone, name: 'Milestone' },
  { id: EquipmentSource.NorthAmerica, name: 'North American' },
  { id: EquipmentSource.Penske, name: 'Penske' },
  { id: EquipmentSource.Premier, name: 'Premier' },
  { id: EquipmentSource.Xtra, name: 'Xtra' },
  { id: EquipmentSource.Other, name: 'Other' },
]

export const TrailerTypeChoices = [
  { id: 'DRY_VAN', name: 'Dry Van' },
  { id: 'FLATBED', name: 'Flatbed' },
  { id: 'REEFER', name: 'Reefer' },
]

export const EquipmentType = {
  Truck: 'TRUCK',
  Trailer: 'TRAILER',
}

export const EquipmentStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Removed: 'REMOVED',
}

export const RoleNames = {
  driver: 'DRIVER',
  admin: 'TEAM_ADMIN',
  owner: 'BUSINESS_OWNER',
}

export const ONBOARDING_STATUSES = [DriverStatus.Applying, DriverStatus.Eligible, DriverStatus.Onboarding]

export const BundleChoices = [
  { id: ProductSubscriptionBundleName.CASH, name: 'Cash' },
  { id: ProductSubscriptionBundleName.FLEX, name: '(Deprecated) Flex' },
  { id: ProductSubscriptionBundleName.FLEX_CLASSIC, name: '(Deprecated) Flex Classic' },
  { id: ProductSubscriptionBundleName.PREMIUM, name: 'Virtual Carrier (Premium)' },
  { id: ProductSubscriptionBundleName.FLEX_STARTER, name: 'Flex' },
  { id: ProductSubscriptionBundleName.CREDIT_ONLY, name: 'Credit Only' },
]
export const SupportedTargetBundleChoices = [
  { id: ProductSubscriptionBundleName.PREMIUM, name: 'Virtual Carrier (Premium)' },
  { id: ProductSubscriptionBundleName.FLEX_STARTER, name: 'Flex' },
  { id: ProductSubscriptionBundleName.CREDIT_ONLY, name: 'Credit Only' },
]

export const IntegrationStatuses = {
  Connected: 'CONNECTED',
  Error: 'ERROR',
  Pending: 'PENDING',
  NotStarted: 'NOT_STARTED',
}

/* Fuel Tax constants */
const START_END_QUARTERS: Record<string, string> = {
  1: 'Jan 1 - Mar 30',
  2: 'Apr 1 - June 30',
  3: 'July 1 - Sept 30',
  4: 'Oct 1 - Dec 31',
}

const START_YEAR = 2021

function get_quarter_choices(START_YEAR: number) {
  const CURRENT_YEAR = new Date().getFullYear()
  const CURRENT_MONTH = new Date().getMonth()
  const CURRENT_QUARTER = Math.ceil((CURRENT_MONTH + 1) / 3)
  var QUARTER_CHOICES = []
  for (let year = CURRENT_YEAR; year >= START_YEAR; year--) {
    const LAST_QUARTER = year !== CURRENT_YEAR ? 4 : CURRENT_QUARTER
    for (let quarter = LAST_QUARTER; quarter >= 1; quarter--) {
      const id = 'QUARTER_YEAR'.replace('YEAR', year.toString()).replace('QUARTER', quarter.toString())
      const name = 'Q_QUARTER - YEAR . '
        .replace('YEAR', year.toString())
        .replace('_QUARTER', quarter.toString())
      const quarter_label = {
        id: id,
        name: name.concat(START_END_QUARTERS[quarter.toString()]),
      }
      QUARTER_CHOICES.push(quarter_label)
    }
  }
  return QUARTER_CHOICES
}

export const QUARTER_CHOICES = get_quarter_choices(START_YEAR)

export const IFTA_CHOICES = [
  { id: 'True', name: 'IFTA Trucks' },
  { id: 'False', name: 'All trucks' },
]

export const maxTotalGallons = 300.0
export const minTotalGallons = 0.001
export const maxPricePerGallon = 9.999
export const minPricePerGallon = 0.001

export const MAX_NUM_TEAMS = 100

export const OnboardingChecklistName = {
  SIGN_AGREEMENT: 'SIGN_AGREEMENT',
  DRIVER_APPLICATION: 'DRIVER_APPLICATION',
  FLEET_APPLICATION: 'FLEET_APPLICATION',
  FLEET_DETAILS: 'FLEET_DETAILS',
  FLEX_AGREEMENT: 'FLEX_AGREEMENT',
  FLEX_STARTER_SUBSCRIPTION: 'FLEX_STARTER_SUBSCRIPTION',
  BACKGROUND_CHECK: 'BACKGROUND_CHECK',
  ADD_DRIVERS: 'ADD_DRIVERS',
  ADD_INDIVIDUAL_DRIVER: 'ADD_INDIVIDUAL_DRIVER',
  TAX_INFO: 'TAX_INFO',
  ELD_SETUP: 'ELD_SETUP',
  EQUIPMENT_SETUP: 'EQUIPMENT_SETUP',
  EQUIPMENT_DOCUMENTS: 'EQUIPMENT_DOCUMENTS',
  ADD_INDIVIDUAL_EQUIPMENT: 'ADD_INDIVIDUAL_EQUIPMENT',
  ADD_INDIVIDUAL_EQUIPMENT_DOCUMENTS: 'ADD_INDIVIDUAL_EQUIPMENT_DOCUMENTS',
  BROKER_SETUP: 'BROKER_SETUP',
  ADD_INDIVIDUAL_BROKER: 'ADD_INDIVIDUAL_BROKER',
  PAYMENT_PROFILE_SETUP: 'PAYMENT_PROFILE_SETUP',
  BANK_ACCOUNT_INFO: 'BANK_ACCOUNT_INFO',
  CONFIRM_CT_CARD_INFO: 'CONFIRM_CT_CARD_INFO',
  STRIPE_PAYMENT_PROFILE: 'STRIPE_PAYMENT_PROFILE',
  INSURANCE_INFORMATION: 'INSURANCE_INFORMATION',
  CREDIT_APPLICATION: 'CREDIT_APPLICATION',
  EMPLOYMENT_HISTORY: 'EMPLOYMENT_HISTORY',
  CONTRACTOR_PAYMENTS_PROFILE: 'CONTRACTOR_PAYMENTS_PROFILE',
  PAYROLL_BANK_ACCOUNT: 'PAYROLL_BANK_ACCOUNT',
  ADD_CONTRACTOR: 'ADD_CONTRACTOR',
  CONTRACTOR_PERSONAL_PROFILE: 'CONTRACTOR_PERSONAL_PROFILE',
  CONTRACTOR_PERSONAL_DIRECT_DEPOSIT: 'CONTRACTOR_PERSONAL_DIRECT_DEPOSIT',
  CONTRACTOR_PERSONAL_DEBIT_CARD: 'CONTRACTOR_PERSONAL_DEBIT_CARD',
  MAINTENANCE_SET_ASIDE: 'MAINTENANCE_SET_ASIDE',
}

export const TaskStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PREREQUISITES_NOT_MET: 'PREREQUISITES_NOT_MET',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
}

export const ELDProviderUrl: Record<any, string> = {
  Samsara: 'https://cloud.samsara.com/signin',
  KeepTruckin: 'https://keeptruckin.com/log-in',
  TruckerCloud: 'https://truckercloud.com/',
}

export const SafetyEmailGradeChoices = [
  { id: 'Excellent', name: 'Excellent' },
  { id: 'Good', name: 'Good' },
  { id: 'Needs Improvement', name: 'Needs Improvement' },
  { id: 'Immediate Attention Required', name: 'Immediate Attention Required' },
]

export const FUEL_RECEIPT_REPORT_LINK =
  'https://datastudio.google.com/u/0/reporting/91549530-ebc2-430f-aad5-46a515f6abf1/page/p5YrC'

export const ACCOUNTING_OFFBOARDING_REQUEST_FORM =
  'https://docs.google.com/forms/d/1lRIlKl3s8bjH8DFpMXnCA0NLj8B0oVDNY5_fz5Nn24E/viewform?edit_requested=true'

export const DocumentType = {
  BillOfLading: 'BILL_OF_LADING',
  RateConfirmation: 'RATE_CONFIRMATION',
  LumperReceipt: 'LUMPER_RECEIPT',
  Other: 'OTHER',
}

export const DocumentTypeChoices = [
  { id: DocumentType.BillOfLading, name: 'Bill of Lading' },
  { id: DocumentType.RateConfirmation, name: 'Rate Confirmation' },
  { id: DocumentType.LumperReceipt, name: 'Lumper Receipt' },
  { id: DocumentType.Other, name: 'Other' },
]

export const GOOGLE_APIS_LOADED = 'GOOGLE_APIS_LOADED'

export const JOB_ALREADY_IN_DESIRED_STATE_ERROR = 'Job is already in desired state'

export const DRIVING_LIMIT = 'DRIVING_LIMIT'
export const DRIVING_BREAK = 'DRIVING_BREAK'
export const ON_DUTY_LIMIT = 'ON_DUTY_LIMIT'
export const CYCLE_LIMIT = 'CYCLE_EIGHT_DAY'

export const AutoApproveFailureReason = {
  FEASIBILITY: 'FEASIBILITY',
  FLAGGED_RATE: 'FLAGGED_RATE',
  RESTRICTED_LOAD_TYPE: 'RESTRICTED_LOAD_TYPE',
  PARSED_DATA_DISCREPANCY: 'PARSED_DATA_DISCREPANCY',
  DATA_VALIDATION_GUARDRAILS: 'DATA_VALIDATION_GUARDRAILS',
  BROKER_AT_RISK: 'BROKER_AT_RISK',
}

export const SUPPORTED_EDI_INVOICE_SHIPPER_FEINS = {
  walmart: '311233',
}

export enum AccessorialRequestType {
  DETENTION = 'DETENTION',
  LAYOVER = 'LAYOVER',
}

export enum AccessorialRequestStatus {
  REQUESTED = 'REQUESTED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export const CloudTrucksLLCMCNumber = '1046672'
export const CTINLLCMCNumber = '1532905'

export const CarrierMCChoices = [
  { id: CloudTrucksLLCMCNumber, name: 'CloudTrucks LLC' },
  { id: CTINLLCMCNumber, name: 'CT IN LLC' },
]

export const CTXLoadExternalStatusChoices = [
  { id: 'quoting', name: 'Quoting' },
  { id: 'quote_accepted', name: 'Quote Accepted' },
  { id: 'appointment_pending', name: 'Appointment Pending' },
  { id: 'auction_running', name: 'Auction Running' },
]
